export enum CommonRouteEnum {
  Root = '/',
  Home = '/home',
  Desktop = '/home/desktop',
}
